<template>
  <div class="cg-main-warp">
    <a-page-header class="cg-main-page-header"
      v-if="!IsSubsys"
      :ghost="false"
    >
      <a-breadcrumb>
        <a-breadcrumb-item v-for="(item, index) in Routes" :key="index">
          {{item.breadcrumbName}}
        </a-breadcrumb-item>
      </a-breadcrumb>
    </a-page-header>
    <!--表单显示区域-->
    <div class="cg-userform-warp">
      <a-spin :tip="CurUserForm.Hint.Tip" :spinning="CurUserForm.Hint.IsShow">
        <UserFromView ref="UserFromView" class="cg-userform-view" @onMount="OnMount" />
      </a-spin>
    </div>
  </div>
</template>
<script>
import UserFromView from "./Components/UserFormView";
import { mapState } from "vuex";

export default {
  props: {
    userForm: {
      type: Object,
      requried: true,
    },
  },
  provide() {
    return {
      userForm: this.CurUserForm,
    };
  },
  components: { UserFromView },
  data() {
    return {};
  },
  computed: {
    ...mapState(["IsSubsys"]),
    CurUserForm() {
      return this.userForm;
    },
    Routes() {
      let _routes = [];

      let _getRoutes = (menuDataList, userFormID, index) => {

        for (let _i = 0; _i < menuDataList.length; _i++) {

          let _menuData = menuDataList[_i];

          _routes[index] = {
            breadcrumbName: _menuData.ModuleDesc,
            MenuData: _menuData,
          };

          var _userForm = null;

          if (
            _menuData.UserForms &&
            (_userForm = _menuData.UserForms.find((item) => item.UserFormID === userFormID))
          ) {
            _routes[index + 1] = {
              breadcrumbName: _userForm.FormDesc,
              MenuData: _userForm
            };
            _routes.length = index + 2;
            return true;
          }

          if (_menuData.Sons && _getRoutes(_menuData.Sons, userFormID, index + 1)) {
            return true;
          }
        }

        return false;
      };

      //找不到，路由就只有当前表单
      if(!_getRoutes(this.$store.state.MenuDataList || [], this.CurUserForm.UserFormID, 0)) {
        _routes = [{
          breadcrumbName: this.CurUserForm.UserFormDesc,
          MenuData: this.CurUserForm
        }];
      }

      return _routes;
    }
  },
  created() {
    this.RenderPromise = null;
    this.RenderResolve = null;
    if (this.CurUserForm.Type === "UserForm") {
      this.CurUserForm.SetVueComponent(this);
    }
  },
  methods: {
    OnMount() {
      if (typeof this.RenderResolve === "function") {
        this.RenderResolve();
      } else {
        this.RenderPromise = Promise.resolve();
      }
      // this.RenderResolve = this.RenderPromise = null;
    },
    LoadUserFormView() {

      this.$refs.UserFromView.LoadUserFormView();

      return (
        this.RenderPromise ||
        (this.RenderPromise = new Promise((resolve) => {
          this.RenderResolve = resolve;
          // this.$refs.UserFromView.LoadUserFormView();
        }))
      );
    },
  },
};
</script>
<style>
.cg-main-warp {
  width: 100%;
  height: 100%;
  overflow: auto;
}
.cg-main-page-header.ant-page-header>.ant-page-header-content{
  padding-top: 0px;
}
</style>
